exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".attachmentPreviewModal-04fb5{width:100%;height:80vh}.noRenderer-f9d77{width:100%;display:flex;align-items:center;justify-content:center}.noRenderer-f9d77 .ant-result-title{font-size:20px}", ""]);

// Exports
exports.locals = {
	"attachmentPreviewModal": "attachmentPreviewModal-04fb5",
	"noRenderer": "noRenderer-f9d77"
};